<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header mb-3">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{
                                isUpdate
                                    ? $t('editar-desconto-qtde')
                                    : $t('adicionar-desconto-qtde')
                            }}
                        </h1>
                    </div>

                    <!-- BOTÃO DE SALVAR -->
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="fecharModal()">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-input
                                :id="generateId(22)"
                                ref="idErpInput"
                                v-model="descontoQuantidade.idprodutoqtdeprecoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!descontoQuantidade.idprodutoqtdeprecoerp"
                                uppercase
                            />
                        </div>

                        <!-- SELEÇÃO DE EMPRESA -->
                        <div class="column is-5">
                            <vss-select
                                :id="generateId(10)"
                                ref="empresaSelect"
                                v-model="empresaSelected"
                                title="empresa"
                                placeholder="msg-selecione-empresa"
                                :required="true"
                                :invalid="empresaSelected == null"
                                :options="empresas"
                                @input="inputEmpresa"
                                :loading="empresaLoading"
                                searchable
                                @search="loadEmpresas"
                                :disabled="isUpdate"
                            />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(80)"
                                ref="situacaoSelect"
                                v-model="situacaoSelected"
                                title="situacao"
                                :required="true"
                                :invalid="situacaoSelected == null"
                                :options="situacaoSelect"
                                :disabled="!isUpdate"
                            />
                        </div>
                        <!-- SELEÇÃO DE TABELA DE PREÇO -->
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(20)"
                                ref="tabprecoSelect"
                                v-model="tabelaPrecoSelected"
                                title="tab-preco"
                                placeholder="msg-selecione-tab-preco"
                                :required="true"
                                :invalid="tabelaPrecoSelected == null"
                                :options="tabelasPrecoSelect"
                                :disabled="!empresaSelected || isUpdate"
                                :loading="tabprecoLoading"
                                searchable
                                @search="loadTabpreco"
                            />
                        </div>
                        <!-- SELEÇÃO DE CLIENTE -->
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(30)"
                                ref="clienteSelect"
                                v-model="clienteSelected"
                                title="cliente"
                                placeholder="msg-selecione-cliente"
                                :options="clienteSelect"
                                :disabled="!empresaSelected || isUpdate"
                                searchable
                                @search="loadCliente"
                                :loading="clientesLoading"
                            />
                        </div>
                        <!-- QUANTIDADE INICIAL -->
                        <div class="column is-3">
                            <v-money
                                :id="generateId(40)"
                                ref="qtdiniInput"
                                v-model="descontoQuantidade.qtdeinicio"
                                title="qtd-ini"
                                tooltipLabel="msg-tooltip-qtde-inicial"
                                tooltipSize="is-small"
                                :required="true"
                                :disabled="!tabelaPrecoSelected"
                                :msg="invalidQtdeinicioMsg"
                                :invalid="invalidQtdeinicio"
                                @onBlurFunction="validateQtdeinicio()"
                                :min="0"
                                :max="99999999.99"
                            />
                        </div>
                        <!-- QUANTIDADE FINAL -->
                        <div class="column is-3">
                            <v-money
                                :id="generateId(50)"
                                ref="qtdfimInput"
                                v-model="descontoQuantidade.qtdefim"
                                title="qtd-fim"
                                tooltipLabel="msg-tooltip-qtde-final"
                                tooltipSize="is-small"
                                :required="true"
                                :disabled="!tabelaPrecoSelected"
                                :msg="invalidQtdefimMsg"
                                :invalid="invalidQtdefim"
                                @onBlurFunction="validateQtdefim()"
                                :min="0"
                                :max="99999999.99"
                            />
                        </div>
                        <!-- DIFERENÇA -->
                        <div class="column is-3">
                            <v-money
                                :id="generateId(60)"
                                ref="diferencaInput"
                                class="height-36"
                                v-model="descontoQuantidade.diferenca"
                                title="diferenca"
                                tooltipLabel="msg-tooltip-diferenca"
                                tooltipSize="is-small"
                                :required="true"
                                :disabled="!tabelaPrecoSelected"
                                :msg="invalidDiferencaMsg"
                                :invalid="invalidDiferenca"
                                @onBlurFunction="validateDiferenca()"
                            />
                        </div>
                        <!-- DESCONTO MÁXIMO -->
                        <div class="column is-3">
                            <v-money
                                :id="generateId(70)"
                                class="height-36"
                                ref="descmaxInput"
                                v-model="descontoQuantidade.descmaximo"
                                title="desc-max"
                                tooltipLabel="msg-tooltip-desc-max"
                                tooltipSize="is-small"
                                tooltipPosition="is-left"
                                :required="true"
                                :disabled="!tabelaPrecoSelected"
                                :msg="invalidDescmaximoMsg"
                                :invalid="invalidDescmaximo"
                                @onBlurFunction="validateDescmaximo()"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//SERVICE
import AssProdutoEmpresaService from '@/services/vendas/empresa/abas/AssProdutoEmpresaService';
import ProdutoQtdePrecoService from '@/services/vendas/cliente/abas/ProdutoQtdePrecoService';
import VenProdutoService from '@/services/vendas/produto/VenProdutoService';
import AssClienteEmpresaService from '@/services/vendas/empresa/abas/AssClienteEmpresaService';

//VALIDATION
import DescontoQuantidadeValidation from '@/services/validations/vendas/DescontoQuantidadeProdutoValidation';

//COMPONENTS
import HideInfo from '@/components/shared/HideInfo';

//UTILS
import Message from '@/models/Message';
import { mapState } from 'vuex';

export default {
    components: {
        HideInfo,
    },
    props: {
        descontoSelected: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            validation: new DescontoQuantidadeValidation(this.$root.msgs),
            service: new ProdutoQtdePrecoService(this.$http, this.$router),
            precoService: new VenProdutoService(this.$http, this.$router),
            empresaService: new AssProdutoEmpresaService(this.$http, this.$router),
            clienteService: new AssClienteEmpresaService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            descontoQuantidade: {
                idprodutoqtdepreco: null,
                idprodutoqtdeprecoerp: null,
                idcliente: null,
                idproduto: this.$route.params.id,
                idtabpreco: null,
                idempresa: null,
                qtdeinicio: 0,
                qtdefim: 0,
                diferenca: 0,
                descmaximo: 0,
                situacao: 1,
            },
            isUpdate: false,

            //listas para receber valores das combobox
            empresas: [],
            tabelasPrecoSelect: [],
            clienteSelect: [],

            //variáveis para armazenar os valores selecionados nas combobox
            clienteSelected: null,
            empresaSelected: null,
            tabelaPrecoSelected: null,

            //booleano para exibir mensagem ao usuário informando-o que a tabela selecionada não se relaciona com o cliente
            asstabprecocliente: false,

            produtosLoading: false,
            invalidQtdeinicio: true,
            invalidQtdeinicioMsg: 'msg-campo-obrigatorio',
            invalidQtdefim: true,
            invalidQtdefimMsg: 'msg-campo-obrigatorio',
            invalidDiferenca: true,
            invalidDiferencaMsg: 'msg-campo-obrigatorio',
            invalidDescmaximo: true,
            invalidDescmaximoMsg: 'msg-campo-obrigatorio',

            clientesLoading: false,
            tabprecoLoading: false,
            empresaLoading: false,

            situacaoSelected: { id: 1, label: this.$t('ativo') },
            situacaoSelect: [
                { id: 1, label: this.$t('ativo') },
                { id: 0, label: this.$t('inativo') },
            ],
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'vendas',
            'clientes',
            'ven-cliente-politica-comercial-desconto-qtde'
        );
        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'cliente' },
            });
        }
        if (this.descontoSelected.idprodutoqtdepreco != 0) {
            this.isUpdate = true;
            this.carregarDados();
        } else {
            this.loadEmpresas();
        }
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        carregarDados() {
            this.descontoQuantidade.idprodutoqtdepreco = this.descontoSelected.idprodutoqtdepreco;
            this.descontoQuantidade.idcliente = this.descontoSelected.idcliente;
            this.descontoQuantidade.idtabpreco = this.descontoSelected.idtabpreco;
            this.descontoQuantidade.idempresa = this.descontoSelected.idempresa;
            this.descontoQuantidade.qtdeinicio = this.descontoSelected.inicio;
            this.descontoQuantidade.qtdefim = this.descontoSelected.fim;
            this.descontoQuantidade.diferenca = this.descontoSelected.diferenca;
            this.descontoQuantidade.descmaximo = this.descontoSelected['desc-max'];
            this.descontoQuantidade.situacao = this.descontoSelected.situacao;
            this.descontoQuantidade.idprodutoqtdeprecoerp = this.descontoSelected.idprodutoqtdeprecoerp;

            this.empresaSelected = {
                id: this.descontoSelected.idempresa,
                label: this.descontoSelected.empresa,
            };
            this.clienteSelected = {
                id: this.descontoSelected.idcliente,
                label: this.descontoSelected.cliente,
            };
            this.tabelaPrecoSelected = {
                id: this.descontoSelected.idtabpreco,
                label: this.descontoSelected.tabelapreco,
            };

            this.situacaoSelected = this.situacaoSelect.filter((e) => {
                return e.id == this.descontoSelected.situacao;
            })[0];
        },
        loadEmpresas(search = '.*') {
            if (this.isUpdate) {
                return;
            }
            this.empresaLoading = true;
            this.empresaService
                .findByIdProduto('nome', 'asc', 0, 20, 3, this.$route.params.id, search)
                .then((body) => {
                    this.empresas = body.content.map((e) => {
                        return { id: e.empresa.idempresa, label: e.empresa.nome };
                    });
                })
                .catch((e) => {
                    this.empresaLoading = false;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                })
                .finally((_) => {
                    this.empresaLoading = false;
                });
        },
        inputEmpresa() {
            this.loadTabpreco();
            this.loadCliente();
        },
        loadTabpreco(search = '.*') {
            if (!this.empresaSelected || this.isUpdate) {
                return;
            }
            this.tabprecoLoading = true;
            let empresa = '0, ';
            empresa += this.empresaSelected.id;
            this.precoService
                .loadPreco(this.$route.params.id, empresa, 'descricao', 'asc', 0, 20, 3, search)
                .then((body) => {
                    this.tabelasPrecoSelect = body.content.map((e) => {
                        return { id: e.tabpreco.idtabpreco, label: e.tabpreco.descricao };
                    });
                })
                .finally((_) => {
                    this.tabprecoLoading = false;
                })
                .catch((e) => {
                    console.error('Erro ao carregar tabela de preço.', e);

                    this.msgs.push(new Message('error', 'msg-erro-tab-preco', true));
                });
        },
        loadCliente(search = '.*') {
            if (!this.empresaSelected || this.isUpdate) {
                return;
            }
            this.clientesLoading = true;
            let empresa = this.empresaSelected.id;
            this.clienteService
                .findAllVendas('nome', 'asc', 0, 20, 3, empresa, search)
                .then((body) => {
                    if (search.trim() == '' || search == '.*') {
                        this.clienteSelect.push({
                            id: 0,
                            label: this.$t('todos'),
                        });
                    }
                    this.clienteSelect = body.content.map((e) => {
                        return { id: e.cliente.idcliente, label: e.cliente.nome };
                    });
                })
                .finally((_) => {
                    this.clientesLoading = false;
                })
                .catch((e) => {
                    console.error('Erro ao carregar cliente.', e);

                    this.msgs.push(new Message('error', 'msg-erro-cliente', true));
                });
        },
        generateId(numberId) {
            return this.$route.name + '-desconto-qtde-' + numberId;
        },
        validateQtdeinicio() {
            if (this.descontoQuantidade.qtdeinicio < 0) {
                this.invalidQtdeinicio = true;
                this.invalidQtdeinicioMsg = 'msg-campo-obrigatorio';
            } else if (!this.validateQuantidade(+this.descontoQuantidade.qtdeinicio)) {
                this.invalidQtdeinicio = true;
                this.invalidQtdeinicioMsg = 'msg-campo-invalido';
            } else {
                this.invalidQtdeinicio = false;
            }
        },
        validateQtdefim() {
            if (this.isNull(this.descontoQuantidade.qtdefim)) {
                this.invalidQtdefim = true;
                this.invalidQtdefimMsg = 'msg-campo-obrigatorio';
            } else if (!this.validateQuantidade(+this.descontoQuantidade.qtdefim)) {
                this.invalidQtdefim = true;
                this.invalidQtdefimMsg = 'msg-campo-invalido';
            } else if (+this.descontoQuantidade.qtdefim <= +this.descontoQuantidade.qtdeinicio) {
                this.invalidQtdefim = true;
                this.invalidQtdefimMsg = 'msg-erro-desc-qtd-ini-fim';
            } else {
                this.invalidQtdefim = false;
            }
        },
        validateDiferenca() {
            if (this.isNull(this.descontoQuantidade.diferenca)) {
                this.invalidDiferenca = true;
                this.invalidDiferencaMsg = 'msg-campo-obrigatorio';
            } else if (!this.validatePorcentagem(+this.descontoQuantidade.diferenca)) {
                this.invalidDiferenca = true;
                this.invalidDiferencaMsg = 'msg-porcentagem-invalida';
            } else {
                this.invalidDiferenca = false;
            }
        },
        validateDescmaximo() {
            if (this.isNull(this.descontoQuantidade.descmaximo)) {
                this.invalidDescmaximo = true;
                this.invalidDescmaximoMsg = 'msg-campo-obrigatorio';
            } else if (!this.validatePorcentagem(+this.descontoQuantidade.descmaximo)) {
                this.invalidDescmaximo = true;
                this.invalidDescmaximoMsg = 'msg-porcentagem-invalida';
            } else {
                this.invalidDescmaximo = false;
            }
        },
        validateQuantidade(valor) {
            return valor > 0 && valor <= 99999999.99;
        },
        save() {
            this.isLoading = true;

            let descontoQuantidadeTemp = Object.assign({}, this.descontoQuantidade);
            descontoQuantidadeTemp.idcliente =
                this.clienteSelected == null ? 0 : this.clienteSelected.id;
            descontoQuantidadeTemp.idtabpreco =
                this.tabelaPrecoSelected == null ? null : this.tabelaPrecoSelected.id;
            descontoQuantidadeTemp.idempresa =
                this.empresaSelected == null ? null : this.empresaSelected.id;
            descontoQuantidadeTemp.situacao =
                this.situacaoSelected == null ? null : this.situacaoSelected.id;

            if (this.validation.validate(descontoQuantidadeTemp, this.$refs)) {
                descontoQuantidadeTemp = this.mapTosave(descontoQuantidadeTemp);
                descontoQuantidadeTemp.idproduto = this.$route.params.id;

                if (
                    +descontoQuantidadeTemp.diferenca == 0 &&
                    +descontoQuantidadeTemp.descmaximo == 0
                ) {
                    this.msgs.push(
                        new Message('alert', 'msg-preencha-diferenca-ou-desconto', true)
                    );
                    this.isLoading = false;
                    return;
                }

                this.isSaving = true;
                this.service
                    .save(descontoQuantidadeTemp, this.$route.meta.abrev)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-desconto-qtde';
                            this.msgs.push(new Message('success', msg, true));
                            this.$emit('fecharModal', true);
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-adicionar-desconto-qtde'
                            );
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body.status == 409) {
                            this.msgs.push(new Message('alert', e.body.message, true));
                        } else {
                            console.error('Erro ao salvar.', e);
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(
                    new Message('alert', 'msg-preencher-campos-obrigatorios-corretamente', true)
                );
                this.isLoading = false;
            }
        },
        fecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
